import Default from "./ReadonlyText";
export * from "./ReadonlyText";
export default Default;
